<template>
  <div>
    <v-toolbar
      :color="toolbarColor"
      :dark="darkToolbar"
      :height="height"
      dense
    >
      <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-toolbar>
    <v-card
      :color="color"
      :tile="true"
      class="mx-auto"
    >
      <v-card-text>
        <slot />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'InfoCard',

  props: {
    title: {
      type: String,
      required: true
    },
    toolbarColor: {
      type: String,
      default: 'grey lighten-3'
    },
    darkToolbar: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'grey lighten-5'
    },
    height: {
      type: String,
      default: '57px'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/InfoCard.vue